import { createContext, useContext } from 'react';

import {
    IConsultationDetailsDto,
    ICorrespondenceThreadDetails,
} from '@/caregiverSpace/shared/model';

type RenderTimelineFn = (
    consultationDetails: IConsultationDetailsDto,
    isVideo: boolean,
) => React.ReactNode;

type RenderCorrespondenceTimelineFn = (
    correspondenceThreadDetails: ICorrespondenceThreadDetails,
) => React.ReactNode;

const TimelineContext = createContext<RenderTimelineFn | null>(null);
const CorrespondenceTimelineContext =
    createContext<RenderCorrespondenceTimelineFn | null>(null);

export const TimelineProvider = TimelineContext.Provider;
export const CorrespondenceTimelineProvider =
    CorrespondenceTimelineContext.Provider;

export const useRenderTimeline = (): RenderTimelineFn => {
    const renderTimeline = useContext(TimelineContext);
    if (!renderTimeline) {
        throw new Error(
            'useRenderTimeline must be used within a TimelineProvider',
        );
    }
    return renderTimeline;
};

export const useRenderCorrespondenceTimeline =
    (): RenderCorrespondenceTimelineFn => {
        const renderCorrespondenceTimeline = useContext(
            CorrespondenceTimelineContext,
        );
        if (!renderCorrespondenceTimeline) {
            throw new Error(
                'useRenderCorrespondenceTimeline must be used within a CorrespondenceTimelineProvider',
            );
        }
        return renderCorrespondenceTimeline;
    };
